/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useTable, usePagination, useFlexLayout, useSortBy } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons/faAngleDown";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons/faAngleUp";
import PageNav from "./PageNav";
import { DataContext } from "../../context/DataContext";
import {
  JUDGE_LIST_OPTIONS,
  JUDGES_PER_PAGE_BREAKPOINT,
} from "../../utils/constants";

const handlePageSize = (width, setPageSize) => {
  if (width < JUDGES_PER_PAGE_BREAKPOINT) {
    setPageSize(3);
  } else {
    setPageSize(4);
  }
};

const CountyJudges = ({ judgesData, changeSelection, county }) => {
  const { mapDims, choroplethColorKey } = useContext(DataContext);
  const handleClick = (id, name) => {
    changeSelection({ id, type: "judge", county, label: name });
  };
  const { header, accessor, sortDesc, sortType } = JUDGE_LIST_OPTIONS[
    choroplethColorKey
  ];
  const columns = React.useMemo(() => {
    return [
      {
        Header: "Judge",
        accessor: "name", // accessor is the "key" in the data
        // disableSortBy: true,
      },
      {
        Header: header,
        accessor,
        sortDescFirst: true,
        sortType,
      },
    ];
  }, [accessor, header, sortType]);
  const defaultColumn = React.useMemo(
    () => ({
      // When using the useFlexLayout:
      minWidth: 50, // minWidth is only used as a limit for resizing
      width: "20%", // width is used for both the flex-basis and flex-grow
      maxWidth: 200, // maxWidth is only used as a limit for resizing
    }),
    []
  );
  const tableInstance = useTable(
    {
      columns,
      defaultColumn,
      data: judgesData,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: 3,
        sortBy: [
          {
            id: accessor,
            desc: sortDesc,
          },
        ],
      },
    },
    useSortBy,
    usePagination,
    useFlexLayout
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setSortBy,
    state: { pageIndex },
  } = tableInstance;

  useEffect(() => {
    handlePageSize(mapDims.width, setPageSize);
    setSortBy([
      {
        id: accessor,
        desc: sortDesc,
        sortType,
      },
    ]);
  }, [accessor, setSortBy, sortType, mapDims.width, sortDesc, setPageSize]);
  return (
    <div className="panel__county-judges-container">
      <div {...getTableProps()} className="panel__table">
        <div className="panel__table-row">
          {
            // Loop over the header rows
            headerGroups.map((headerGroup) => (
              // Apply the header row props
              <div {...headerGroup.getHeaderGroupProps()}>
                {
                  // Loop over the headers in each row
                  headerGroup.headers.map((column) => (
                    // Apply the header cell props
                    // Render the header
                    <div
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="panel__table-cell text-emphasis"
                    >
                      {column.render("Header")}{" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </div>
                  ))
                }
              </div>
            ))
          }
        </div>
        {/* Apply the table body props */}
        <div {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            const { id, name } = row.original;
            return (
              <div
                {...row.getRowProps()}
                className="panel__table-row hover-effect"
                onClick={() => handleClick(id, name)}
              >
                {row.cells.map((cell) => {
                  if (cell.column.Header === "Judge") {
                    return (
                      <div
                        {...cell.getCellProps()}
                        className="panel__table-cell nowrap"
                      >
                        <FontAwesomeIcon
                          className="panel__table-icon-chevron"
                          icon={faChevronCircleRight}
                        />
                        {cell.render("Cell")}
                      </div>
                    );
                  }
                  return (
                    <div {...cell.getCellProps()} className="panel__table-cell">
                      {cell.render("Cell")}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
      {pageCount > 1 && (
        <PageNav
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          pageOptions={pageOptions}
          pageCount={pageCount}
          gotoPage={gotoPage}
          nextPage={nextPage}
          previousPage={previousPage}
          pageIndex={pageIndex}
        />
      )}
    </div>
  );
};

CountyJudges.propTypes = {
  judgesData: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  changeSelection: PropTypes.func.isRequired,
  county: PropTypes.string.isRequired,
};

export default CountyJudges;
